import * as React from 'react';
import {Component, ReactNode, RefObject} from 'react';
import * as _ from 'lodash';
import {IStoryData, IStoryDataOut, IVideo} from '../../../../service/contentServer';
import ReactHtmlParser, {convertNodeToElement, processNodes} from 'react-html-parser';
import {contentParse} from './contentParsed.functions';
import {getVideoComponentFromVideoData} from '../../../components/biz/video';
import {getDirection} from '../../../common/language';
import {Cache} from 'lru-cache';
import {devConsole} from '../../../../const/code';
import {getImgWithIdAndImageData} from '../../../components/biz/image';

let performance = null;

let memoryCache: Cache<string, any> ;
const TAG_AD = 'TAG_AD';

if (process.env.BROWSER) {
  require('./contentParsed.less');
} else {
  const lru = require('lru-cache');
  // 缓存在内存 1 分钟
  const cacheOptions = { max: 1000, maxAge: 1 * 60 * 1000 };
  memoryCache = lru(cacheOptions);
}

if (!process.env.BROWSER && process.env.NODE_ENV === 'development') {
   performance = require('perf_hooks').performance;
}

interface IContentParsedProps {
  story: IStoryDataOut;
  insertAdAfterId?: string;
  insertAdComponent?: React.ReactNode;
}
interface IContentParsedState {}

interface INode {
  type: string;
  name: string;
  children: INode[];
  next: INode;
  prev: INode;
  parent: INode;
  data: string;
  attribs: any;
}

function placeHolder(): ReactNode {

  return <span className="placeholder">
          </span>;
}

export default class ContentParsed extends Component<IContentParsedProps, IContentParsedState> {
  public outDiv: RefObject<any>;
  public firstImage = true;
  constructor(props) {
    super(props);
    this.state = {};
    this.outDiv = React.createRef();
  }

  public transform(node: INode, index) {
    // console.log('transform>', node, index);
    // res-image
    if (node.type === 'tag' && node.name === 'res-image' ) {

      // console.log('transform>', node.children);
      const id = node.attribs.id;
      return getImgWithIdAndImageData(id, this.props.story.raw_item.image, false);
      // res-video
    } else if (node.type === 'tag' && node.name === 'res-video' ) {
      const id = node.attribs.id;
      if (id) {
        node.parent && node.parent.name === 'p' && (node.parent.name = 'div');
        const video = _.find(this.props.story.raw_item.video, (o) => o.id === id) as IVideo;
        return getVideoComponentFromVideoData(video, 'w-article-video');
      }
    } else if ( node.type === 'tag' && node.name === 'res-gallery') {
      const ids: string = node.attribs.ids;
      return <div key={`gallery-${ids}`}> {ids.split(',').map((id) => {
        return getImgWithIdAndImageData(id, this.props.story.raw_item.image, true);
      })}</div>;
    } else if ( node.type === 'tag' && node.name === TAG_AD) {
      return this.props.insertAdComponent;
    }
  }

  public parseHtmlWithCache(raw: IStoryData) {
    const th = this;

    function recursiveGiveId(node, prefixId) {
      node.dataId = prefixId;
      if (!node.attribs) {
        node.attribs = {};
      }
      node.attribs['data-id'] = prefixId;
      node.attribs.key = prefixId;
      let needInsertAdAfterPos = null;
      if (node.children) {
        for (let i = 0; i < node.children.length; i++) {
          const child = node.children[i];
          const r = recursiveGiveId(child, prefixId + '-' + i);
          if (r && !needInsertAdAfterPos) {
            needInsertAdAfterPos = i;
          }
        }
        if (needInsertAdAfterPos !== null) {
          node.children.splice(needInsertAdAfterPos + 1, 0, {type: 'tag', name: TAG_AD});
        }
      }
      if (th.props.insertAdAfterId && prefixId === th.props.insertAdAfterId) {
        return true;
      }
    }

    function realParse() {
      return ReactHtmlParser(contentParse(raw), {
        // @ts-ignore
        transform: (node, index) => {
          return th.transform(node as any, index);
        },
        preprocessNodes: (nodes) => {
          recursiveGiveId({children: nodes}, 'E');
          // console.log(nodes);
          return nodes;
        },
      });
    }

    if (!process.env.BROWSER) {
      const md5 = require('md5');
      const key = md5(raw.content);
      const got = memoryCache.get(key);
      if (got) {
        devConsole('parseHtmlWithCache > got cache', key);
        return got;
      } else {
        const r = realParse();
        memoryCache.set(key, r);
        return r;
      }
    } else {
      return realParse();
    }

  }

  public render(): ReactNode {
    this.firstImage = true;

    if (!process.env.BROWSER && process.env.NODE_ENV === 'development') {
      performance.mark('A');
    }

    // <div dangerouslySetInnerHTML={{__html: contentParse(this.props.story.raw_item)}} />
    const r = <div ref={this.outDiv} className="article-content-parsed"
                style={{direction: getDirection(this.props.story.raw_item)}}>{
                    this.parseHtmlWithCache(this.props.story.raw_item)
       }</div>;

    if (!process.env.BROWSER && process.env.NODE_ENV === 'development') {
      performance.mark('B');
      performance.measure('ReactHtmlParserTime', 'A', 'B');
      // const entry = performance.getEntriesByName('ReactHtmlParserTime', 'measure');
      // console.log('ReactHtmlParserTime_MS', entry[0].duration);
    }

    return r;
  }

}
